import { createMockMapIndustrialArea } from '../../industrial-area/mock/map-industrial-area.mock';
import type { MapRegion } from '../map-region.model';
import { buildUaeMapRegionsDemo } from './uae-regions.adapter';

/** Canonical default fixture for {@link MapRegion}. */
export const MOCK_MAP_REGION: MapRegion = {
  id: 1,
  country_id: 1,
  name: 'Mock Region',
  industrial_areas: [createMockMapIndustrialArea()],
};

/** Returns a {@link MapRegion} merged with the supplied overrides. */
export function createMockMapRegion(
  overrides: Partial<MapRegion> = {}
): MapRegion {
  return { ...MOCK_MAP_REGION, ...overrides };
}

/**
 * Returns a list of unique {@link MapRegion} fixtures.
 * @param count - Number of fixtures to create. Defaults to `3`.
 * @param overrideAt - Optional callback returning per-index overrides.
 */
export function createMockMapRegionList(
  count = 3,
  overrideAt?: (index: number) => Partial<MapRegion>
): MapRegion[] {
  return Array.from({ length: count }, (_, index) => {
    const regionId = index + 1;
    return createMockMapRegion({
      id: regionId,
      name: `Mock Region ${regionId}`,
      industrial_areas: [
        createMockMapIndustrialArea({
          id: regionId * 10,
          name: `Mock Industrial Area ${regionId}`,
          region_id: regionId,
        }),
      ],
      ...overrideAt?.(index),
    });
  });
}

/**
 * UAE regions with industrial-area polygons from `samples/regions.json`
 * (adapted into `uae-regions.sample.json`).
 *
 * Seven emirates, 36 industrial areas with OSM (or irregular fallback)
 * polygon coordinates and official websites when available. Area `id`s
 * align with `MOCK_MAP_FACTORIES_DEMO` and the factory showcase seed.
 *
 * Used as the default seed for {@link regionHandlers} in the demo build.
 */
export const MOCK_MAP_REGIONS_DEMO: MapRegion[] = buildUaeMapRegionsDemo();
